import { memo } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  items: (number | string)[]
  selected?: number
  prefix?: string
  sufix?: string
  onSelect?: (v: number) => void
}

export const SelectableButton = memo(
  ({ items, selected, prefix = '', sufix = '', onSelect }: Props) => (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => {
        const isSelected = selected === item
        const isNumber = typeof item === 'number'

        return (
          <button
            key={item}
            onClick={() => isNumber && onSelect?.(item)}
            className={twMerge(
              `w-20 h-10 py-2 rounded-full border font-medium transition ${
                isSelected
                  ? 'bg-blue-100 border-blue-500 text-blue-600'
                  : 'border-gray-300 text-gray-600'
              }`,
            )}
          >
            {prefix} {item} {sufix}
          </button>
        )
      })}
    </div>
  ),
)

SelectableButton.displayName = 'SelectableButton'
